import { http } from '../plugins/http'
import { type AxiosResponse } from 'axios'

import User from '@/types/User'
import type PaginatedResponse from '@/types/PaginatedResponse'
import DataResponse from '@/types/DataResponse'
import Order from '@/types/Order'

export default class UserService {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<User>>> {
    return await http.get<PaginatedResponse<User>>(`/api/v1/office/users?page=${page}&${filters}&per_page=${per_page}`)
  }

  async show(id: string): Promise<AxiosResponse<DataResponse<User>>> {
    return await http.get<DataResponse<User>>(`/api/v1/office/users/${id}`)
  }

  async update(model: User): Promise<AxiosResponse<DataResponse<User>>> {
    return await http.put<DataResponse<User>>(`/api/v1/office/users/${model.id}`, model)
  }

  async orders(page: number, filters: string, per_page: number | undefined = 10, id: string): Promise<AxiosResponse<PaginatedResponse<Order>>> {
    return await http.get<PaginatedResponse<Order>>(`/api/v1/office/users/${id}/orders?page=${page}&${filters}&per_page=${per_page}`)
  }

  async report(filters: string, selected: Record<string, string>): Promise<AxiosResponse<BlobPart>> {
    filters = (filters !== '') ? `?${filters}` : ''

    return await http.post(`/api/v1/office/users${filters}`,
      { selected },
      {
        headers: {
          Accept: 'application/csv',
        },
      },
    )
  }
}
